import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
    const [contactNumber, setContactNumber] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const navigate = useNavigate();
  
    const handleContactNumberChange = (e) => setContactNumber(e.target.value);
  
    const handleSendOtp = async (e) => {
      e.preventDefault();
      try {
        const response = await axios.post('https://doc.teamhalt.com/document/api/v1/forget-password/', { contact_number: contactNumber });
        // const response = await axios.post('http://127.0.0.1:8000/document/api/v1/forget-password/', { contact_number: contactNumber });
        if (response.data.message) {
          setSuccess(response.data.message);
          navigate('/reset-password', { state: { contactNumber } });
        } else {
          setError('Failed to send OTP. Please try again.');
        }
      } catch (error) {
        console.error('Error sending OTP:', error);
        setError('Error sending OTP. Please try again.');
      }
    };

  return (
    <div className="auth-wrapper">
  <form className="auth-card" onSubmit={handleSendOtp}>
    <div className="logo-container">
      <img src="logo.png" alt="Logo" className="logo" />
      <h1 className="logo-name">TeamHalt Document Manager</h1>
    </div>
    <h2>Forgot Password</h2>
    <input
      type="tel"
      name="contactNumber"
      placeholder="Enter your Contact Number"
      value={contactNumber}
      onChange={handleContactNumberChange}
      required
    />
    {error && <p className="error">{error}</p>}
    {success && <p className="success">{success}</p>}
    <button type="submit">Send OTP</button>
    <Link className="link" to="/">Go Back To Login</Link>
  </form>
</div>

  );
};

export default ForgotPassword;